import React, { useState, useLayoutEffect } from 'react';
import SVG from 'react-inlinesvg'
import classnames from 'classnames';

import cup from '@src/images/landing/cup';
import cupWithStars from '@src/images/landing/cup-with-stars';
import stars from '@src/images/landing/stars';
import finishFlag from '@src/images/landing/flags/finish';
import teacherRoutes from '@app/routes/teacherRoutes';

const WarmUpBanner = ({ event }) => {
  const [isHomeRoute, setIsHomeRoute] = useState(false);

  useLayoutEffect(() => {
    setIsHomeRoute(window.location.pathname.endsWith(teacherRoutes.Home.path))
  }, []);

  const getBadgeStatus = () => {
    if (event?.atMainTour) {
      return 'ongoing';
    } else if (event?.afterMainTour) {
      return 'over';
    }
    return 'warmup';
  }

  const getBadgeText = () => {
    switch(getBadgeStatus()) {
      case 'ongoing':
        return "Olympiad Is On!";
      case 'over':
        return "Main Round is Over!";
      default:
        return "Warm Up Stage";
    }
  }

  const isAfterMainTour = event?.state === 'after_main_tour';
  const isAfterMainTourWithoutAwards =
    isAfterMainTour && event?.awards_available === false;

  const renderInviteStudentsCTA = () => {
    if (!isHomeRoute) {
      return null;
    }

    const inviteClasses = classnames('warmup-banner__invite', {
      'warmup-banner__invite--after-main': isAfterMainTourWithoutAwards,
    });

    if (isAfterMainTourWithoutAwards) {
      return (
        <div className={inviteClasses}>
          <SVG src={finishFlag} className="warmup-banner__invite-cup" />
          <div className="warmup-banner__invite-title">
            Main&nbsp;Round is&nbsp;Over
          </div>
          <div className="warmup-banner__invite-hint">
            Certificates and results will be available here soon. Students who qualify
            for the Final&nbsp;Round will be invited to participate through their schools and chat&nbsp;messages.
          </div>
        </div>
      )
    }

    if (isAfterMainTour) {
      return null;
    }

    return (
      <div className={inviteClasses}>
        <SVG src={stars} className="warmup-banner__invite-stars" />
        <SVG src={cupWithStars} className="warmup-banner__invite-cup" />
        <div className="warmup-banner__invite-title">
            Invite Your&nbsp;Students
        </div>
        <div className="warmup-banner__invite-hint">
          Tell your classes about the Olympiad and have them
          go&nbsp;to&nbsp;Dinolab and compete!
        </div>
      </div>
    )
  }

  const badgeClasses = classnames(
    'warmup-banner__badge',
    `warmup-banner__badge--${getBadgeStatus()}`
  );

  return (
    <div className="warmup-banner">
      <div className={badgeClasses}>
        {getBadgeText()}
      </div>
      <div className="warmup-banner__content">
        <div>
          <SVG src={cup} className="warmup-banner__content-left" />
        </div>
        <div className="warmup-banner__content-right">
          <div className="warmup-banner__title">
            Free Online Olympiad
          </div>
          <div className="warmup-banner__hint">
            5+ Lakh Participants Competed!
          </div>
        </div>
      </div>
      {renderInviteStudentsCTA()}
    </div>
  )
}

export default WarmUpBanner;